import { render, staticRenderFns } from "./DynamicSectionLoader.vue?vue&type=template&id=79c49790"
import script from "./DynamicSectionLoader.vue?vue&type=script&lang=js"
export * from "./DynamicSectionLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports